
<!--
 * @Description: 办公 临时工作 完成
 * @Author: PF
 * @Date: 2023-03-22 19:04:23
 * @LastEditors: PF
 * @LastEditTime: 2024-02-05 10:25:01
-->
<template>
  <div>
    <el-dialog class="w800 hp80" :model-value="openWanCheng" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">完成</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openWanCheng', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-form ref="ruleFormRef" :model="ruleForm" label-width="130px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="工作任务标题">{{grgzrwData.gzrwbt}}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="要求完成时间">{{grgzrwData.yqwcsj}}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="开始时间" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-date-picker type="datetime" v-model="ruleForm.kssj" format="YYYY-MM-DD HH:mm" value-format="YYYY-MM-DD HH:mm" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="完成时间" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-date-picker type="datetime" v-model="ruleForm.wcsj" @change="shiFouAnShiWanCheng" format="YYYY-MM-DD HH:mm" value-format="YYYY-MM-DD HH:mm" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item v-if="!sfaswc" label="未按时完成说明" prop="waswcsm" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-input type="textarea" v-model="ruleForm.waswcsm" clearable resize="none" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="工作总结">
              <ueditor v-model:value="ruleForm.gzzj" :row="{height:350}" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button type="primary" @click="submit()">保存</el-button>
            <el-button type="info" @click="closeWindow('openWanCheng', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, ref, watch, unref } from 'vue'
import { closeWindow, submitForm, loadSelect } from '@/api/common.js'
import { getDate } from '@/utils/index.js'
import ueditor from '@/components/ueditor.vue'

const props = defineProps({
  openWanCheng: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['update:openWanCheng', 'ReturnData'])
const ruleFormRef = ref(null)
const ruleForm = ref({
  wcsj: ''
})
const row = ref()
const grgzrwData = ref({
  yqwcsj: ''
})
const sfaswc = ref(true)

// 比较两个日期大小。格式：2018-8-12 12:30
const compareDate2 = (d1, d2) => {
  const date1 = new Date(Date.parse(d1))
  const date2 = new Date(Date.parse(d2))
  return date1 > date2
}
// 是否按时完成
const shiFouAnShiWanCheng = () => {
  if (compareDate2(ruleForm.value.wcsj, grgzrwData.value.yqwcsj)) {
    sfaswc.value = false
  } else {
    sfaswc.value = true
  }
}

// 提交
const submit = async () => {
  submitForm({
    url: '/api/v2/bangong/bangongdaibanshixiang/finishgerengongzuorenwu',
    ruleFormRef: unref(ruleFormRef),
    ruleForm: ruleForm.value,
    callback: function (res) {
      closeWindow('openWanCheng', emits, true)
    }
  })
}
watch(
  () => props.openWanCheng,
  () => {
    if (props.openWanCheng) {
      row.value = props.row
      ruleForm.value.id = props.row.id
      ruleForm.value.kssj = getDate('YYYY', 'MM', 'DD') + ' 09:00'
      ruleForm.value.wcsj = getDate('YYYY', 'MM', 'DD', 'HH', 'mm')
      // 查询要求完成时间
      loadSelect({
        url: '/api/v2/bangong/bangongdaibanshixiang/bangong/' + ruleForm.value.id,
        data: grgzrwData,
        loadSuccess: function (ref) {
          
          shiFouAnShiWanCheng()
        }
      })
    }
  },
  { deep: true, immediate: true }
)
</script>
<style lang="less" scoped>
:deep(.el-card__body) {
  height: calc(100% - 72px);
  overflow: auto;
}
</style>
